import { useQuery } from '@tanstack/react-query';
import type { ProductListQuery } from '@sshop/domain';

import { productListQuery } from './productListQuery';

export const useProductFeed = (filters: ProductListQuery, enabled = true) =>
  useQuery({ ...productListQuery(filters), enabled });
